// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e4f95e8f","455":"e475e95f","977":"90141b0e"}[chunkId] + ".chunk.js";
};